const TermsCondition =()=>{
    return(
        <div>
            <p className="text-dark">
                Thank you for choosing WALKINTOTHEWILD (“The Platform”) to serve you with the Jungle Safari Experience. The platform ensures that it deliver great customer experience. However, there may arise cases where dissatisfaction is expressed for our offerings in terms of products and services. To ensure transparency and fairness, we have outlined our cancellation policy below;
            </p>

            <strong className="mt-3">Cancellation by the Customer</strong>
            <p className="ms-5">
                Due to the sensitive nature of forest permits and limited availability, the following terms apply:
            </p>

            <p className="mb-1 mt-3">
                <strong>Before</strong> safari permit issue date <strong>:</strong> Standard cancellation charges of INR 5,000/- will be retained as administrative charges and rest amount will be refunded to the customer.
            </p>
            <p className="">
                <strong>Once</strong> the safari permit is <strong>issued</strong><strong>:</strong> Customer will not be eligible for any refund.
            </p>

            <p className="mt-4 mb-1"><strong>Non-Refundable Components</strong></p>

            <p className="mb-1">
                Forest Permits and Entry Fees are non-refundable under any circumstances once booked.
            </p>
            <p className="mb-1">
                Certain resorts or hotel bookings may be partially or fully non-refundable depending on property’s terms.
            </p>
            <p>
                Transportation arrangements (Jeep Rentals or Transfers etc.) are subject to vendor specific cancellation policy.
            </p>

            <p className="ms-5 mt-4">
                <strong>#.</strong>
                <i>It is clarified that in the case of non-refundable bookings, the entire booking amount require to be received prior to confirmation and shall not be refundable under any circumstances to the Traveler.</i>
            </p>

            <p className="mt-4 mb-1">
                <strong>Cancellation by “The Platform” or “The Operators of the Platform”</strong>
            </p>
            <p className="ms-5">The Platform reserves the right to cancel the safari due to;</p>

            <p>Unavailability of confirmed rooms, safari slots or essential travel services even after booking has been confirmed</p>

            <p className="ms-5">
                In such cases, customer will be entitled to <strong>“Full Refund”</strong>  or an option to  <strong>re-schedule</strong>, subject to availability.
            </p>

            <p className="mt-4 mb-1"><strong>Cancellation due to Force Majeure and Unforeseen Events</strong></p>
            <p className="ms-5">WALKINTOTHEWILD is not liable for cancellations or service disruptions due to:</p>

            <p className="mt-4 mb-1">Unforeseen weather conditions</p>
            <p className="mb-1">Government restrictions or forest closures</p>
            <p className="mb-1">Natural calamities or safety concerns</p>
            <p className="mb-1">Riots, strikes, curfews, natural disasters, terrorism, wars, adverse weather, or similar force majeure conditions.</p>
            <p className="mb-1">
                If attractions are closed due to such circumstances, efforts will be made for partial refunds or the credit notes/vouchers or to reschedule the itinerary subject to availability, but there is no obligation.
            </p>

            <p className="mt-4"><strong>Refund Timelines</strong></p>
            <p>
                All eligible refunds will be processed within 21 business days of the cancellation.
            </p>
            <p>
                Payment made by debit/credit card or NEFT/RTGS or any other mode (except cash) will be refunded back to the original payment source only.
            </p>

            <p className="mt-4"><strong>Modifications</strong></p>
            <p>Changes in travel plans are allowed only once, and at least 30 days prior to the scheduled safari date.</p>
            <p>All modifications are subject to availability and may incur additional charges.</p>

            <p className="mt-4"><strong>Travel Insurance</strong></p>
            <p className="ms-5 mt-2">
                We <span>strongly recommend</span>  that all customers purchase comprehensive travel insurance to cover unexpected/potential losses arising from <span>cancellations, accidents, medical emergencies, delays</span> , or other unforeseen events during the entire duration of travel, including but not limited to jungle safaris.
            </p>
            <p className="ms-5 mt-2">
                WALKINTOTHEWILD does not offer travel insurance services  directly. We advise customers to obtain suitable coverage through reliable/reputable insurance agencies, financial institutions or the banks.
            </p>

            <p className="mt-2"><strong>Limitation of Liability</strong></p>
            <p className="mt-2">
                To the maximum extent permitted by law, WALKINTOTHEWILD’s liability is limited to the amount of fees actually received by WALKINTOTHEWILD from the Traveler under the relevant booking. WALKINTOTHEWILD will not be liable for indirect, incidental, special, or consequential damages, or for any failure or deficiency in services provided by Operators.
            </p>
            <p className="mt-2">
                Nothing in this Policy shall exclude liability for death or personal injury caused by negligence, or any other liability which cannot be excluded or limited under applicable law.
            </p>
            <p className="mt-2">
                All travelers must strictly adhere to the laws and regulations governing forest areas and jungle safaris. These rules are implemented by local forest departments to ensure visitor safety and wildlife conservation. WALKINTOTHEWILD shall not be held liable for any consequences, including fines or legal actions, resulting from a traveler’s non-compliance with these regulations.
            </p>

            <p className="mt-2"><strong>Governing Law and Jurisdiction</strong></p>
            <p className="ms-5">
                This Policy shall be governed in accordance with the laws of India and any disputes arising out of or in connection with the Policy shall be subject to exclusive jurisdiction of courts in New Delhi, India.
            </p>

            <p className="mt-4"><strong>General</strong></p>
            <p className="mt-2">
                This Policy forms an integral part of the User Agreement and constitutes a binding legal contract between the Traveler and WALKINTOTHEWILD.
            </p>

            <p className="mt-2">
                WALKINTOTHEWILD reserves the right to modify or amend this Policy at any time without prior notice. The updated Policy will be published on the official website and such changes will be effective from the date of publication.
            </p>
        </div>
    )
}

export default TermsCondition